import { schema } from 'normalizr';

const tag = new schema.Entity('tag');

export default tag;
